import "./NotOnKanaDeveloperInviteFields.css";

import { ErrorBox, InformationBox } from "../../cards";
import { TextInput } from "../../forms";
import { Column, Row } from "../../layout";
import { getErrorMessages, hasFieldError } from "../utils";
import { NotOnKanaDeveloperInviteFieldsProps } from "./models";

export const NotOnKanaDeveloperInviteFields = ({
  value,
  onChange,
  errors,
}: NotOnKanaDeveloperInviteFieldsProps): JSX.Element => {
  return (
    <div className="NotOnKanaDeveloperInviteFields">
      <Row spacingV="ml">
        <Column span={12}>
          <InformationBox variant="info">
            <p className="body2">
              We will email an invitation to join Kana. Once they accept, their organisation is created and the project
              access you choose here is applied.
            </p>
          </InformationBox>
        </Column>
      </Row>

      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox
              title="Please solve the below issues before sending the invitation"
              text={getErrorMessages(errors)}
            />
          </Column>
        </Row>
      )}

      <Row spacingV="ml">
        <Column span={6}>
          <TextInput
            label="Email address"
            name="not-on-kana-email"
            type="email"
            value={value.email}
            onChange={(email) => onChange({ ...value, email })}
            hasError={hasFieldError(errors, "email")}
          />
        </Column>
        <Column span={6}>
          <TextInput
            label="Organisation name"
            name="not-on-kana-organisation-name"
            value={value.organisationDisplayName}
            onChange={(organisationDisplayName) => onChange({ ...value, organisationDisplayName })}
            hasError={hasFieldError(errors, "organisationDisplayName")}
          />
        </Column>
      </Row>

      <Row spacingV="ll">
        <Column span={6}>
          <TextInput
            label="First name"
            name="not-on-kana-first-name"
            value={value.invitedUserFirstName}
            onChange={(invitedUserFirstName) => onChange({ ...value, invitedUserFirstName })}
            hasError={hasFieldError(errors, "invitedUserFirstName")}
          />
        </Column>
        <Column span={6}>
          <TextInput
            label="Last name"
            name="not-on-kana-last-name"
            value={value.invitedUserLastName}
            onChange={(invitedUserLastName) => onChange({ ...value, invitedUserLastName })}
            hasError={hasFieldError(errors, "invitedUserLastName")}
          />
        </Column>
      </Row>
    </div>
  );
};
